import styled from 'styled-components'
import colors from '@settings/styleSettings'

export const Icon = styled.div`
display: flex;
align-items: center;
justify-content: center;
width: 60px;
height: 60px;
border-radius: 50%;
background-color: ${colors.softGray};
color: ${colors.strongGray};
`

export const Title = styled.div`
font-size: 20px;
font-weight: bold;
color: ${colors.strongGray};
`

export const Subtitle = styled.div`
text-align: center;
font-size: 16px;
color: ${colors.strongGray};
`

export const Container = styled.div`
display: flex;
flex-direction: column;
align-items: center;
justify-content: center;
padding: 50px;
gap: 10px;
`
